
import * as INTERFACE from './interface';
export * from './interface';
export default INTERFACE;


// WEBPACK FOOTER //
// webpack://paypal/node_modules/beaver-logger/client/index.js